import { render, staticRenderFns } from "./ListCase.vue?vue&type=template&id=cdffef8c&scoped=true&"
import script from "./ListCase.vue?vue&type=script&lang=js&"
export * from "./ListCase.vue?vue&type=script&lang=js&"
import style0 from "./ListCase.vue?vue&type=style&index=0&id=cdffef8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdffef8c",
  null
  
)

export default component.exports